import React from 'react'

function NotFound() {
  return (
    <div style={{fontSize: '1.5rem'}}>404 | Not Found</div>
  )
}

export default NotFound